import React, { FC, useState } from "react";
import { useSetAtom } from "jotai";
import { setModalCloseAtom } from "atoms/modalAtom/modalAtom";
import {
  useAddDiscountItem,
  useClientTransaction,
} from "features/ClientInfo/api";

import { Button, EButtonVariant } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { DialogContent } from "components/DialogContent/DialogContent";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { NamedCounter } from "components/NamedCounter/NamedCounter";
import { NamedInput } from "components/NamedInput/NamedInput";

import { useClientsState } from "../../../atoms/clientsAtom";

export const AccureBonusesModal: FC = () => {
  const { clientsState } = useClientsState();
  const [bonus, setBonus] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const closeModal = useSetAtom(setModalCloseAtom);
  const { mutateAsync: clientTransactionAsync } = useClientTransaction();

  const onDiscountClick = async () => {
    if (clientsState.activeItems.length) {
      const promises: Promise<any>[] = [];

      clientsState.activeItems.forEach((item) => {
        promises.push(
          clientTransactionAsync({
            total: +bonus,
            comment: comment,
            clientid: item.clientid,
            action: "add",
          })
        );
      });

      await Promise.all(promises);
    }

    closeModal();
  };

  return (
    <DialogContent
      style={{ width: "600px", padding: "0 20px", alignItems: "flex-start" }}
    >
      <VerticalSpace size={56} />
      <NamedCounter
        title="Начислить бонусы:"
        value={bonus}
        titleWidth={130}
        onChange={(e) => setBonus(e.target.value)}
      />
      <VerticalSpace size={56} />
      <NamedInput
        label={"Комментарий"}
        value={comment}
        onChange={(ev) => setComment(ev.target.value)}
        inputWidth={400}
      />
      <VerticalSpace size={56} />
      <div className="flex flex-row justify-center w-full">
        <Button onClick={closeModal} variant={EButtonVariant.TERTIARY}>
          Назад
        </Button>
        <HorizontalSpace size={5} />
        <Button
          variant={EButtonVariant.SECONDARY}
          disabled={!bonus}
          onClick={onDiscountClick}
        >
          Начислить
        </Button>
      </div>
      <VerticalSpace size={30} />
    </DialogContent>
  );
};
